export const calcSalary = (order, payment) => {
	return (
		(order.big_items_count - (order.ignore_bonus_big_items_count || 0)) *
			payment.delivered_commision +
		(order.small_items_count - (order.ignore_bonus_small_items_count || 0)) *
			payment.additional_item_commision
	);
};
